import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showError: false,
  errorMessage: "",
  errorTitle: "",
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = true;
      state.errorMessage = action.payload.message || '';
      state.errorTitle = action.payload.title || '';
    },
    clearError: (state) => {
      state.showError = false;
      state.errorMessage = "";
      state.errorTitle = "";
    },
  },
});


export const { setError, clearError } = errorSlice.actions;
export default errorSlice;
